<template>
  <div>
    <v-row>
      <v-col align="left">
        <v-card
          rounded
          color="cardIsland"
          class="mx-auto mt-12"
          max-width="374"
        >
          <v-card-title>Create a {{orderType}} order</v-card-title>
          <v-divider></v-divider>
          <v-card-title style="font-size:16px" class="pb-0">
            1. Choose coin
          </v-card-title>
          <v-card-text>
            <v-select
              class="mt-2"
              v-model="selectedCoin"
              outlined
              dense
              placeholder="Select one"
              :items="coins"
              hide-details
            >
              <!-- <template v-slot:selection="{ item }">
                <img :src="item.icon">{{ item.name }}
              </template>
              <template v-slot:item="{ item }">
                <img :src="item.icon">{{ item.name }}
              </template> -->
              <template v-slot:selection="{ item }">
                <img src="../../assets/icons/btc.svg">&nbsp;&nbsp;{{ item.name }}
              </template>
              <template v-slot:item="{ item }">
                <img src="../../assets/icons/btc.svg">&nbsp;&nbsp;{{ item.name }}
              </template>
            </v-select>
          </v-card-text>
          <v-divider class="my-4"></v-divider>
          <v-card-title style="font-size:16px" class="py-0">
            2. Enter amount
          </v-card-title>
          <v-card-text>
            <div v-if="orderType === 'buy'">
              <v-text-field
                v-model="audAmount"
                label="You pay"
                outlined
                dense
                suffix="AUD"
                placeholder="0.00"
                type="number"
                hide-details
                class="mt-2"
                @blur="handleInputBlur(`forms.wallet.audAmount`)"
                @input="hideValidationErrorMsg(`forms.wallet.audAmount`); calculateCoinAmount(audAmount)"
              ></v-text-field>
              <ValidationErrorMsg :validation-data="getInputValidationData(`forms.wallet.audAmount`)" />
              <v-text-field
                v-model="coinAmount"
                label="You get"
                class="mt-2"
                outlined
                dense
                suffix="BTC"
                placeholder="0.00"
                type="number"
                hide-details
                @blur="handleInputBlur(`forms.wallet.coinAmount`)"
                @input="hideValidationErrorMsg(`forms.wallet.coinAmount`); calculateAudAmount(coinAmount)"
              ></v-text-field>
              <ValidationErrorMsg :validation-data="getInputValidationData(`forms.wallet.coinAmount`)" />
            </div>
            <div v-if="orderType === 'sell'">
              <v-text-field
                v-model="coinAmount"
                label="You sell"
                class="mt-2"
                outlined
                dense
                suffix="BTC"
                placeholder="0.00"
                type="number"
                hide-details
                @blur="handleInputBlur(`forms.${addressType}.coinAmount`)"
                @input="hideValidationErrorMsg(`forms.${addressType}.coinAmount`); calculateAudAmount(coinAmount)"
              ></v-text-field>
              <ValidationErrorMsg :validation-data="getInputValidationData(`forms.${addressType}.coinAmount`)" />
              <v-text-field
                v-model="audAmount"
                label="You send"
                class="mt-2"
                outlined
                dense
                suffix="AUD"
                placeholder="0.00"
                type="number"
                hide-details
                @blur="handleInputBlur(`forms.${addressType}.audAmount`)"
                @input="hideValidationErrorMsg(`forms.${addressType}.audAmount`); calculateCoinAmount(audAmount)"
              ></v-text-field>
              <ValidationErrorMsg :validation-data="getInputValidationData(`forms.${addressType}.audAmount`)" />
            </div>
          </v-card-text>
          <v-divider class="my-4"></v-divider>
          <v-card-title style="font-size:16px" class="py-0">
            3. To address
          </v-card-title>
          <v-card-text>
            <!-- <v-radio-group
              v-model="isNewAddressSelected"
              row
              dense
              class="my-0"
              hide-details
            >
              <v-radio
                label="Saved"
                :value="false"
              ></v-radio>
              <v-radio
                label="New"
                :value="true"
              ></v-radio>
            </v-radio-group> -->
            <v-btn-toggle
              v-if="orderType === 'sell'"
              dense
              mandatory
              style="width:100%"
              class="mt-2"
            >
              <v-btn
                @click="addressType = 'bank'"
                style="width:50%"
                checked
                color="cardIslandLighter"
              >
                <v-icon
                  class="mr-1"
                  small
                  color="white"
                >mdi-bank</v-icon>
                Bank
              </v-btn>
              <v-btn
                @click="addressType = 'bpay'"
                style="width:50%"
                color="cardIslandLighter"
              >
                <v-icon
                  class="mr-1"
                  small
                  color="white"
                >mdi-receipt</v-icon>
                Bpay
              </v-btn>
            </v-btn-toggle>
            <v-autocomplete
              v-if="!saveNewAddress"
              @change="presetAddressFields"
              :items="addresses"
              v-model="savedAddressSelected[addressType]"
              item-text="address.nickname"
              item-value="id"
              :return-object="true"
              :label="savedAddressSelected[addressType] ? undefined :'Search address book...'"
              :prepend-inner-icon="savedAddressSelected[addressType] ? undefined : 'mdi-magnify'"
              hide-details
              dense
              outlined
              class="mt-2"
            >
            </v-autocomplete>
            <div v-if="addressType === 'wallet'">
              <v-text-field
                v-model="address.wallet.nickname"
                v-if="saveNewAddress"
                label="Address nickname"
                placeholder="Enter nickname for address book"
                dense
                hide-details
                outlined
                class="mb-2 mt-2"
                @blur="handleInputBlur(`forms.walletNewAddress.nickname`)"
                @input="hideValidationErrorMsg(`forms.walletNewAddress.nickname`)"
              >
              </v-text-field>
              <ValidationErrorMsg
                v-if="saveNewAddress"
                :validation-data="getInputValidationData(`forms.walletNewAddress.nickname`)"
              />
              <v-text-field
                v-model="address.wallet.address"
                label="Wallet address"
                placeholder="Enter wallet address"
                dense
                hide-details
                outlined
                class="mt-2"
                @blur="handleInputBlur(`forms.wallet.address`)"
                @input="hideValidationErrorMsg(`forms.wallet.address`); addressInputHandler()"
              >
              </v-text-field>
              <ValidationErrorMsg :validation-data="getInputValidationData(`forms.wallet.address`)" />
            </div>
            <div v-if="addressType === 'bank'">
              <v-text-field
                v-if="saveNewAddress"
                v-model="address.bank.nickname"
                label="Address nickname"
                placeholder="Enter nickname for address book"
                dense
                hide-details
                outlined
                class="mt-2"
                @blur="handleInputBlur(`forms.bankNewAddress.nickname`)"
                @input="hideValidationErrorMsg(`forms.bankNewAddress.nickname`)"
              >
              </v-text-field>
              <ValidationErrorMsg
                v-if="saveNewAddress"
                :validation-data="getInputValidationData(`forms.bankNewAddress.nickname`)"
              />
              <v-text-field
                v-model="address.bank.bsb"
                label="BSB"
                placeholder="Enter BSB"
                dense
                hide-details
                outlined
                class="mt-2"
                @blur="handleInputBlur(`forms.bank.bsb`)"
                @input="hideValidationErrorMsg(`forms.bank.bsb`); addressInputHandler()"
              >
              </v-text-field>
              <ValidationErrorMsg :validation-data="getInputValidationData(`forms.bank.bsb`)" />
              <v-text-field
                v-model="address.bank.accountNumber"
                label="Account Number"
                placeholder="Enter account number"
                dense
                hide-details
                outlined
                class="mt-2"
                @blur="handleInputBlur(`forms.bank.accountNumber`)"
                @input="hideValidationErrorMsg(`forms.bank.accountNumber`); addressInputHandler()"
              >
              </v-text-field>
              <ValidationErrorMsg :validation-data="getInputValidationData(`forms.bank.accountNumber`)" />
              <v-text-field
                v-model="address.bank.accountName"
                label="Account Name (optional)"
                placeholder="Enter account name (optional)"
                dense
                hide-details
                outlined
                class="mt-2"
              >
              </v-text-field>
            </div>
            <div v-if="addressType === 'bpay'">
              <v-text-field
                v-if="saveNewAddress"
                v-model="address.bpay.nickname"
                label="Address nickname"
                placeholder="Enter nickname for address book"
                dense
                hide-details
                outlined
                class="mt-2"
                @blur="handleInputBlur(`forms.bpayNewAddress.nickname`)"
                @input="hideValidationErrorMsg(`forms.bpayNewAddress.nickname`)"
              >
              </v-text-field>
              <ValidationErrorMsg
                v-if="saveNewAddress"
                :validation-data="getInputValidationData(`forms.bpayNewAddress.nickname`)"
              />
              <v-text-field
                v-model="address.bpay.biller"
                label="Biller code"
                placeholder="Enter biller code"
                dense
                hide-details
                outlined
                class="mt-2"
                @blur="handleInputBlur(`forms.bpay.biller`)"
                @input="hideValidationErrorMsg(`forms.bpay.biller`); addressInputHandler()"
              >
              </v-text-field>
              <ValidationErrorMsg :validation-data="getInputValidationData(`forms.bpay.biller`)" />
              <v-text-field
                v-model="address.bpay.ref"
                label="Reference"
                placeholder="Enter customer reference"
                dense
                hide-details
                outlined
                class="mt-2"
                @blur="handleInputBlur(`forms.bpay.ref`)"
                @input="hideValidationErrorMsg(`forms.bpay.ref`); addressInputHandler()"
              >
              </v-text-field>
              <ValidationErrorMsg :validation-data="getInputValidationData(`forms.bpay.ref`)" />
            </div>
            <v-switch
              label="Save to address book"
              inset
              v-model="saveNewAddress"
              hide-details
              color="primary"
              :disabled="isSwitchDisabled"
              class="mt-2 ml-1"
            ></v-switch>
          </v-card-text>
          <!-- </template> -->
          <v-divider class="mt-4"></v-divider>
          <v-card-text>
            <v-btn
              @click="reviewOrder"
              block
              class="mt-2"
              color="primary"
              :loading="isLoading"
            >Review transaction &rightarrow;</v-btn>
            <div class="mt-4">
              The price above is only an estimate. The final price will be calculated on the next page and
              will be locked in for 60 seconds or if market prices fluctuate more than 2% (whichever comes first).
              You'll have a chance to review and confirm the transaction before making any committments.
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import ValidationErrorMsg from '../../components/ValidationErrorMsg.vue'
import { validateValues, _get, _set } from '../../helpers/validation.js';

export default {
  props: ["orderType"],
  components: {
    ValidationErrorMsg,
  },
  data() {
    return {
      isLoading: false,
      isSwitchDisabled: false,
      addressType: null,
      saveNewAddress: false,
      audAmount: null,
      coinAmount: null,
      transactionCost: 20,
      savedAddressSelected: {
        wallet: null,
        bank: null,
        bpay: null,
      },
      address: {
        wallet: {
          nickname: null,
          address: null,
        },
        bank: {
          nickname: null,
          bsb: null,
          accountNumber: null,
          accountName: null,
        },
        bpay: {
          nickname: null,
          biller: null,
          ref: null,
        },
      },
      btcPriceSell: null,
      btcPriceBuy: null,
      coins: [{ id: 'btc', name: 'Bitcoin', icon: '../../assets/icons/btc.svg' }],
      selectedCoin: { id: 'btc', name: 'Bitcoin', icon: '../../assets/icons/btc.svg' },
      forms: {
        wallet: {
          audAmount: {
            path: "audAmount",
            validationRulesPath: "audAmountRules",
            showErrorMsg: false,
          },
          coinAmount: {
            path: "coinAmount",
            validationRulesPath: "requiredOnlyRules",
            showErrorMsg: false,
          },
          address: {
            path: "address.wallet.address",
            validationRulesPath: "requiredOnlyRules",
            showErrorMsg: false,
          },
        },
        bank: {
          audAmount: {
            path: "audAmount",
            validationRulesPath: "audAmountRules",
            showErrorMsg: false,
          },
          coinAmount: {
            path: "coinAmount",
            validationRulesPath: "requiredOnlyRules",
            showErrorMsg: false,
          },
          bsb: {
            path: "address.bank.bsb",
            validationRulesPath: "numbersOnlyRules",
            showErrorMsg: false,
          },
          accountNumber: {
            path: "address.bank.accountNumber",
            validationRulesPath: "numbersOnlyRules",
            showErrorMsg: false,
          }
        },
        bpay: {
          audAmount: {
            path: "audAmount",
            validationRulesPath: "audAmountRules",
            showErrorMsg: false,
          },
          coinAmount: {
            path: "coinAmount",
            validationRulesPath: "requiredOnlyRules",
            showErrorMsg: false,
          },
          biller: {
            path: "address.bpay.biller",
            validationRulesPath: "numbersOnlyRules",
            showErrorMsg: false,
          },
          ref: {
            path: "address.bpay.ref",
            validationRulesPath: "numbersOnlyRules",
            showErrorMsg: false,
          },
        },
        walletNewAddress: {
          nickname: {
            path: `address.wallet.nickname`,
            validationRulesPath: "requiredOnlyRules",
            showErrorMsg: false,
          },
        },
        bankNewAddress: {
          nickname: {
            path: `address.bank.nickname`,
            validationRulesPath: "requiredOnlyRules",
            showErrorMsg: false,
          },
        },
        bpayNewAddress: {
          nickname: {
            path: `address.bpay.nickname`,
            validationRulesPath: "requiredOnlyRules",
            showErrorMsg: false,
          },
        },
      },
      requiredOnlyRules: [
        {
          name: 'required',
          validateRule: function (val, rule) {
            return rule.validate(val);
          }
        },
      ],
      numbersOnlyRules: [
        {
          name: 'required',
          validateRule: function (val, rule) {
            return rule.validate(val);
          }
        },
        {
          name: 'numbersOnly',
          validateRule: function (val, rule) {
            return rule.validate(val);
          }
        },
      ],
      audAmountRules: [
        {
          name: 'required',
          validateRule: function (val, rule) {
            return rule.validate(val);
          }
        },
        {
          name: 'orderLimitMin',
          validateRule: function (val, rule) {
            return rule.validate(val, 30);
          }
        },
        {
          name: 'orderLimitMax',
          validateRule: function (val, rule) {
            return rule.validate(val, 50);
          }
        },
      ]
    }
  },
  computed: {
    ...mapState("auth", ["accessToken"]),
    ...mapState('order', ['order']),
    ...mapGetters("address", ["walletAddresses", "bankAddresses", "bpayAddresses",]),
    addresses() {
      return this[`${this.addressType}Addresses`]
    },
    formType() {
      return this.saveNewAddress ? 'newAddress' : 'savedAddress'
    },
  },
  methods: {
    ...mapMutations("order", ["setOrder"]),
    ...mapActions("auth", ["getAccessToken"]),
    ...mapActions("address", ["getAddresses"]),
    handleInputBlur(inputMetadataPath) {
      let { inputMetadata, val } = this.getInputValidationData(inputMetadataPath);
      inputMetadata.showErrorMsg = true;
      if (inputMetadata === null) {
        return;
      }
      if (val === null || val === undefined) {
        _set(this, inputMetadata.path, "");
      }
    },
    getInputValidationData(inputMetadataPath) {
      let inputMetadata = _get(this, inputMetadataPath);
      if (!inputMetadata) console.log("Couldn't find this path:", inputMetadataPath);
      let val = _get(this, inputMetadata.path);
      let rules = _get(this, inputMetadata.validationRulesPath);
      return { inputMetadata, val, rules };
    },
    hideValidationErrorMsg(inputMetadataPath) {
      let { inputMetadata } = this.getInputValidationData(inputMetadataPath);
      inputMetadata.showErrorMsg = false;
    },
    showValidationErrorMsgsByForm(formMetadataName) {
      let formMetadata = _get(this, formMetadataName);
      for (const item of Object.values(formMetadata)) {
        item.showErrorMsg = true;
      }
    },
    validateInputsByForm(formMetadataName) {
      let formMetadata = _get(this, formMetadataName);
      // sanitizing form
      for (const key of Object.keys(formMetadata)) {
        let inputMetadata = formMetadata[key];
        let val = _get(this, inputMetadata.path);
        if (typeof (val) !== 'boolean') {
          val = val === null || val === undefined ? "" : val;
          val = val.trim();
        }
        _set(this, inputMetadata.path, val);
      }
      // validating form
      let valueAndRulesArray = Object.keys(formMetadata).map((i) => {
        let inputMetadata = formMetadata[i];
        let value = _get(this, inputMetadata.path);
        let rules = _get(this, inputMetadata.validationRulesPath);
        return { value, rules };
      });
      return validateValues(valueAndRulesArray);
    },
    addressInputHandler() {
      this.savedAddressSelected[this.addressType] = null
      this.isSwitchDisabled = false
    },
    presetAddressFields() {
      this.address[this.addressType] = { ...this.savedAddressSelected[this.addressType].address }
      this.address[this.addressType].nickname = null
      this.isSwitchDisabled = true
    },
    async reviewOrder() {
      const isFormValid = this.validateInputsByForm(`forms.${this.addressType}`);
      if (!isFormValid) {
        this.showValidationErrorMsgsByForm(`forms.${this.addressType}`);
        return;
      }

      if (this.saveNewAddress) {
        const isNicknameFilledOut = this.validateInputsByForm(`forms.${this.addressType}NewAddress`);
        if (!isNicknameFilledOut) {
          this.showValidationErrorMsgsByForm(`forms.${this.addressType}NewAddress`);
          return;
        }
      }

      this.isLoading = true
      const order =
      {
        orderType: this.orderType,
        status: 'unpaid',
        coin: this.selectedCoin.id,
        audAmount: this.audAmount,
        addressType: this.addressType,
        address: this.address[this.addressType],
        saveNewAddress: this.saveNewAddress,
      }
      try {
        await this.getAccessToken()
        const response = await fetch(`${process.env.VUE_APP_API_URL}/orders/`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.accessToken}`,
          },
          body: JSON.stringify(order)
        })
        const finalOrder = await response.json()
        this.setOrder(finalOrder)
        this.$emit('submit')
      } catch (error) {
        console.log(error)
      }
      this.isLoading = false
    },
    calculateAudAmount(val) {
      if (this.orderType === 'buy') this.audAmount = (val * this.btcPriceBuy + this.transactionCost).toFixed(2)
      if (this.orderType === 'sell') this.audAmount = (val * this.btcPriceSell + this.transactionCost).toFixed(2)
    },
    calculateCoinAmount(val) {
      if (!val) return null
      if (this.orderType === 'buy') this.coinAmount = ((val - this.transactionCost) / this.btcPriceBuy).toFixed(8)
      if (this.orderType === 'sell') this.coinAmount = ((val - this.transactionCost) / this.btcPriceSell).toFixed(8)
    },
    async getLivePrices() {
      try {
        const response = await fetch('https://api.btcmarkets.net/v3/markets/BTC-AUD/ticker')
        const btcTicker = await response.json()
        this.btcPriceBuy = Number(btcTicker.bestBid)
        this.btcPriceSell = Number(btcTicker.bestAsk)
        if (this.audAmount) this.calculateCoinAmount(this.audAmount)
        console.log('buy price updated to:', this.btcPriceBuy)
        console.log('sell price updated to:', this.btcPriceSell)
      } catch (error) {
        console.log(error)
      }
    },
  },
  created() {
    this.addressType = this.orderType === 'buy' ? 'wallet' : 'bank'
  },
  async mounted() {
    await this.getLivePrices()
    await this.getAddresses()
    const getLivePrices = setInterval(this.getLivePrices, 10000)
    this.$once("hook:beforeDestroy", () => {
      clearInterval(getLivePrices);
    });

    this.$nextTick(() => {
      this.setOrder(null)
    })
  },
}
</script>

<style>
</style>